export default "/_next/static/images/carousel-right-arrow-49331cdfca853699b107d3b0c86d1338.svg";